import React from "react";
import List from "./List";
import swal from "sweetalert";

import Server from "../../../../services/Server";
//import cryptFunctions from '../../../../services/cryptPassword';

const SubscribersList = (props) => {
  const { currentUser = {} } = props,
    { uid, customLogo = false } = currentUser,
    eventData = {
      id: props.event.id,
      name: props.event.name,
      url: props.event.url,
      startDate: props.event.startDate.format("DD [de] MMM [de] YYYY, HH:mm"),
      gmt: props.event.gmt,
      uid: uid,
      hasCustomBrand: customLogo,
      eventCustomBrand: props.event.customLogo || false,
    };

  const { login_methods = {} } = props.event,
    { code = false, email = false } = login_methods;

  const onlyCode = code && !email;

  eventData.hasAccessCode = code;
  eventData.onlyCode = onlyCode;

  const [GlobalFilter, setGlobalFilter] = React.useState("ALL");

  const [selectAll, setSelectAll] = React.useState(false);

  const _defaultFields = [
    {
      text: "",
      sortable: false,
    },
    {
      text: "",
      sortable: false,
    },
    {
      text: "Nombre",
      parameter: "displayName",
      sortable: true,
    },
    {
      text: "Estado",
      parameter: "status",
      sortable: true,
    },
  ];

  if (code) {
    if (_defaultFields.length === 4) {
      _defaultFields.splice(3, 0, {
        text: "Código de Acceso",
        parameter: code,
        sortable: true,
      });
    }
  }

  props.subscribersTemplate.forEach((row) => {
    const pos = _defaultFields.length - 1;
    _defaultFields.splice(pos, 0, {
      text: row.name,
      parameter: row.index,
      sortable: true,
    });
  });

  _defaultFields.push({
    text: "Fecha de Creación",
    parameter: "time",
    sortable: true,
  });

  const onMainCheckerClick = () => {
    const inputs = document.querySelectorAll("td.subscribers-checkbox input");
    inputs.forEach((_input) => {
      if (!selectAll) {
        if (!_input.checked) {
          _input.click();
        }
      } else {
        if (_input.checked) {
          _input.click();
        }
      }
    });

    setSelectAll(!selectAll);
  };

  const onCheckChange = (e, subscriber) => {
    if (e.target.checked) {
      e.target.parentElement.parentElement.parentElement.classList.add(
        "selected"
      );
    } else {
      e.target.parentElement.parentElement.parentElement.classList.remove(
        "selected"
      );
    }

    if (selectAll && !e.target.checked) {
      setSelectAll(false);
    }
  };

  const onDeleteMassive = () => {
    swal({
      title: "",
      text: "Se eliminarán los usuarios seleccionados, ¿Estas seguro?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((will) => {
      if (will) {
        const subscribers = getCheckedInputs();
        subscribers.forEach((subscriber) => {
          props.deleteSubscriber(subscriber, false);
        });
      }
    });
  };

  const onSendConfirmationEmail = () => {
    const subscribers = getCheckedInputs();
    subscribers.forEach((subscriber) => {
      Server.sendConfirmationEmail({ ...subscriber }, eventData)
        .then(() => {
          swal({
            title: "",
            text: "El correo ha sido enviado",
            icon: "success",
            buttons: false,
            dangerMode: false,
          });
        })
        .catch(() => {
          swal({
            title: "",
            text: `Hubo un error con ${subscriber.name}, con correo ${subscriber.email}, por favor revisa sus datos e intentalo nuevamente`,
            icon: "error",
            buttons: false,
            dangerMode: false,
          });
        });
    });
  };

  const onRejectMassive = () => {
    swal({
      title: "",
      text: "Se cambiará el estado de los registros seleccionado a Pendiente, ¿Estas seguro?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((will) => {
      if (will) {
        const subscribers = getCheckedInputs();
        subscribers.forEach((subscriber) => {
          props.onChangeStatus(subscriber, "pending", true);
        });
      }
    });
  };

  return (
    <List
      {...props}
      code={code}
      headerFields={_defaultFields}
      GlobalFilter={GlobalFilter}
      setGlobalFilter={setGlobalFilter}
      selectAll={selectAll}
      onMainCheckerClick={onMainCheckerClick}
      onRejectMassive={onRejectMassive}
      onSendConfirmationEmail={onSendConfirmationEmail}
      onDeleteMassive={onDeleteMassive}
      onCheckChange={onCheckChange}
    />
  );
};

export default SubscribersList;

const getCheckedInputs = () => {
  const inputs = document.querySelectorAll(
    "td.subscribers-checkbox input:checked"
  );
  const _arr = [];
  inputs.forEach((_input) => {
    _arr.push({
      id: _input.attributes.getNamedItem("data-id").value,
      name: _input.attributes.getNamedItem("data-name").value,
      password: _input.attributes.getNamedItem("data-password").value,
      email: _input.attributes.getNamedItem("data-email").value,
      code: _input.attributes.getNamedItem("data-code").value,
    });
  });
  return _arr;
};
